module.exports = __webpack_public_path__ + "static/media/editor.297b17c1.png";